package com.appsyde.shared.modules.ai.domain.usecase

import com.appsyde.shared.modules.ai.domain.repository.AiRepositoryV2

/**
 * Triggers server-side preload for the given message IDs.
 * Server processes up to 4 extracts in parallel (fire-and-forget).
 */
class PreloadAiExtractsUseCase(
    private val repo: AiRepositoryV2
) {
    suspend operator fun invoke(messageIds: List<String>, force: Boolean = false) {
        if (messageIds.isEmpty()) return
        repo.preloadByMessageIds(messageIds, force)
    }
}
